document.addEventListener("DOMContentLoaded", () => {
  // 产品 metafields 变体
  const url = location.href;
  let is_true = false;
  $(".pro-metafields-variants ul li a").each(function () {
    if ($(this).attr("href") != "" && url === $(this).attr("href")) {
      is_true = true;
      $(this).parent().addClass("act");
    } else {
      $(this).parent().removeClass("act");
    }
  });
  if (!url || is_true == false) {
    $(".pro-metafields-variants ul li").eq(0).addClass("act");
  }

  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  };

  const variantSelect = () => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type !== "childList") return;

        const $targetLabels = $('.product-form__input[index="2"] label');
        if (!$targetLabels.length) return;

        observer.disconnect();

        $targetLabels.each((_, label) => {
          try {
            $(label).trigger("click");
          } catch (error) {
            console.error("Error triggering click:", error);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  // $(document).on(
  //   "click",
  //   '.product-form__input[index="1"] label',
  //   debounce(variantSelect, 300)
  // );
});
